import { RizGames } from './index.ts';

/**
 * The UMD entry point. Creators load one script tag and use `window.RizGames`;
 * the module entry is for anyone with a bundler.
 */
declare global {
  interface Window {
    RizGames?: typeof RizGames;
  }
}

if (typeof window !== 'undefined' && !window.RizGames) {
  window.RizGames = RizGames;
}

export { RizGames };
export default RizGames;
